module.exports = __webpack_public_path__ + "img/df-avatar.17c20c12.svg";